import React, { useState } from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {connect} from "react-redux";
import Alert from "@material-ui/lab/Alert";
import {useHistory} from "react-router-dom";
import StyledButton from "../../../components/UI/StyledButton";
import {Box} from "@material-ui/core";
import VehicleListItem from "./VehicleList";
import VehicleWarningModal from '../modals/VehicleWarningModal';

const useStyles = makeStyles((theme) => ({
    title: {
        fontSize: '24px',
        marginBlockEnd: '8px'
    }
}));

const Vehicle = (props) => {

    const classes = useStyles();
    const history = useHistory();

    const [warningState, warningSetState] = useState({state: false, source: 0});

    const warning = {
        state: warningState.state,
        source: warningState.source, //0 - add, 1 - edit
        setState: function (state, source = 0) {
            warningSetState({state, source})
        },
        getMessage: function () {
            if (warningState.source) {
                return `This feature is currently disabled. To edit a vehicle, please contact your Carwiser Agent and they can edit the vehicle for you and generate some offers!`
            }
            else {
                return `This feature is currently disabled. To add a new vehicle, please contact your Carwiser Agent and they can add the vehicle for you and generate some offers!`
            }
        }
    }

    return (
        <React.Fragment>
            <h1 className={classes.title}>My Vehicles</h1>
            {props.error &&
            <div className={`$classes.wrapper`}>
                <Alert severity="error">{props.error.message ?? ''}</Alert>
            </div>
            }
            <VehicleListItem warning={warning}/>
            <Box display="flex" justifyContent="flex-end">
                <StyledButton
                    buttonProps={{
                        variant: "contained",
                        color: "primary",
                        onClick: () => {
                            // history.push('/dashboard/vehicle/add');
                            warning.setState(true, 0);
                        },
                        className: classes.button
                    }}
                    label={'Add Vehicle'}
                />
            </Box>
            <VehicleWarningModal open={warning.state} handleClose={() => warning.setState(false, warning.source)} message={warning.getMessage()}/>
        </React.Fragment>
    );
}

const mapStateToProps = state => {
    return {};
};

const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Vehicle);